import { Transferred, useObservable, RemSize } from '@streem/sdk-react';
import { Theme } from '@streem/ui-react';
import { FC } from 'react';
import { streem } from 'streem-sdk-protobuf';
import { useDetailSession } from '../../../hooks/detail_session_hooks';

interface CallDetailTransferredProps {
    transferred: boolean;
    transferredToTrade?: string;
    requeued: boolean;
}

const mapDataToCallTransferProps = (
    details: streem.api.ICallDetail,
): CallDetailTransferredProps => {
    return {
        transferred: !!details.transferred,
        transferredToTrade: details.transferToGroupName,
        requeued: !!details.requeued,
    };
};

/**
 * this component is responsible for gathering the call transfer data for a room
 */
export const CallDetailTransferred: FC = () => {
    const detailSession = useDetailSession();
    const [room] = useObservable(detailSession.room.room);

    const callTransferProps = room?.callDetail
        ? mapDataToCallTransferProps(room?.callDetail)
        : undefined;
    if (callTransferProps == null) {
        return null;
    }

    return <CallDetailTransferredComponent {...callTransferProps} />;
};

/**
 * this component is responsible for rendering the call transfer data for a room
 **/
const CallDetailTransferredComponent = ({
    transferred,
    transferredToTrade,
    requeued,
}: CallDetailTransferredProps) => {
    return (
        <Transferred
            transferred={transferred}
            transferredToTrade={transferredToTrade}
            requeued={requeued}
            dataIdPrefix="post-call-details"
            transferredStyles={{
                titleFontSize: Theme.text.size.notQuiteAllTheWayMediumLarge as RemSize,
            }}
            keyValueStyles={{ fontSize: Theme.text.size.medium as RemSize }}
        />
    );
};
